import { axiosInstance } from "api/axios-config/axios-config";
import { GetProductsWarehouse } from "api/models/request/product-warehouse/get-products-warehouse";
import { Pagination } from "api/models/response/pagination";
import { IProductInventoryProperties } from "mobx-stores/_models/product-inventory/product-inventory";

class ProductWarehouseBussiness {
  readonly url = "/api/app/product-warehouse";
  public getProductsWarehouse = async (request: GetProductsWarehouse) => {
    try {
      var res = await axiosInstance.get<
        Pagination<IProductInventoryProperties>
      >(this.url, {
        params: request,
      });
      return res.data;
    } catch (error) {
      console.error("Fail getProductsWarehouse", error);
      return Promise.reject(error);
    }
  };

  public getProductWarehouse = async (id: string) => {
    try {
      var res = await axiosInstance.get<GetProductsWarehouse>(
        `${this.url}/${id}`
      );
      return res.data;
    } catch (error) {
      console.error("Fail getProductWarehouse", error);
      return Promise.reject(error);
    }
  };
}

export const productWarehouseBussiness = new ProductWarehouseBussiness();
